import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-upload",
  "use": "svg_i-upload-usage",
  "viewBox": "0 0 19 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 15\" id=\"svg_i-upload\"><path d=\"M4.923 12C2.756 12 1 10.358 1 8.333c0-1.638 1.15-3.026 2.737-3.496C4.25 2.643 6.344 1 8.847 1c1.935 0 3.626.983 4.53 2.445h.046C15.951 3.444 18 5.36 18 7.721c0 1.982-1.443 3.65-3.4 4.135M10 14V7\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><path d=\"m7 9 2.646-2.646a.5.5 0 0 1 .708 0L13 9\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol